import React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import { withTranslations } from 'react-utilities';
import { translationConfig } from './translation.config';
import GamesList from './containers/GamesList';
import SortGameContainer from './containers/SortGameContainer';
import SortDetail from '../../../ts/react/sortDetail/SortDetail';

function App(props) {
  return (
    <HashRouter>
      <Route exact path='/' render={() => <GamesList {...props} />} />
      <Route
        exact
        path='/sortName/:sortName'
        render={routeProps => {
          let finalProps = { ...routeProps };
          finalProps = Object.assign(finalProps, props);
          return <SortGameContainer {...finalProps} />;
        }}
      />
      <Route exact path='/sortName/v2/:sortName' component={SortDetail} />
    </HashRouter>
  );
}

export default withTranslations(App, translationConfig);
